import type { OtpResponse, QuoteData, QuoteInitiateResponse, QuoteResult } from "./types";

const API_BASE = import.meta.env.VITE_API_BASE ?? "/api";

async function request<T>(path: string, init: RequestInit & { partner: string }): Promise<T> {
  const { partner, ...rest } = init;
  const url = new URL(API_BASE + path, window.location.origin);
  url.searchParams.set("partner", partner);

  const resp = await fetch(url.toString(), {
    ...rest,
    headers: {
      "Content-Type": "application/json",
      ...(rest.headers ?? {}),
    },
  });

  if (!resp.ok) {
    let detail = `HTTP ${resp.status}`;
    try {
      const body = await resp.json();
      if (typeof body.detail === "string") detail = body.detail;
      else if (Array.isArray(body.detail) && body.detail[0]?.msg) detail = body.detail[0].msg;
    } catch {
      // ignore
    }
    throw new Error(detail);
  }

  return (await resp.json()) as T;
}

export async function initiateQuote(
  partner: string,
  data: QuoteData
): Promise<QuoteInitiateResponse> {
  return request<QuoteInitiateResponse>("/quote/initiate", {
    partner,
    method: "POST",
    body: JSON.stringify({ partner, ...data }),
  });
}

export async function requestOtp(
  partner: string,
  quoteId: string,
  phone: string,
  consentProcessing: boolean,
  consentContact: boolean
): Promise<OtpResponse> {
  return request<OtpResponse>("/quote/request-otp", {
    partner,
    method: "POST",
    body: JSON.stringify({
      quote_id: quoteId,
      phone,
      consent_processing: consentProcessing,
      consent_marketing: consentContact,
    }),
  });
}

export async function requestConsultation(
  partner: string,
  quoteId: string
): Promise<{ ok: boolean }> {
  return request<{ ok: boolean }>("/quote/request-consultation", {
    partner,
    method: "POST",
    body: JSON.stringify({ quote_id: quoteId }),
  });
}

export async function verifyOtp(
  partner: string,
  quoteId: string,
  code: string
): Promise<QuoteResult> {
  return request<QuoteResult>("/quote/verify-otp", {
    partner,
    method: "POST",
    body: JSON.stringify({ quote_id: quoteId, code }),
  });
}
